import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { UiToastPosition } from './ui-toast.types';
import { UiToastService } from './ui-toast.service';

@Component({
  selector: 'ui-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ui-toast.component.html',
  styleUrl: './ui-toast.component.scss'
})
export class UiToastComponent {
  /** DaisyUI toast position utilities. */
  @Input() position: UiToastPosition = 'top-end';

  /** Custom classes for the toast container. */
  @Input() className = '';

  /** Custom classes applied to each toast item. */
  @Input() itemClassName = '';

  /** If true, render title above content when provided. */
  @Input() showTitle = true;

  constructor(public toastService: UiToastService) {}

  dismiss(id: string) {
    this.toastService.dismiss(id);
  }

  get positionClasses(): string {
    // DaisyUI uses "toast" + (toast-top|toast-middle|toast-bottom) + (toast-start|toast-center|toast-end)
    const [verticalRaw, horizontalRaw] = this.position.split('-') as [string, string];

    const vertical = verticalRaw === 'middle' ? 'toast-middle' : `toast-${verticalRaw}`;
    const horizontal = `toast-${horizontalRaw}`;

    return ['toast', vertical, horizontal, this.className].filter(Boolean).join(' ');
  }

  toastAlertClass(variant: string): string {
    // DaisyUI expects `alert` plus optionally `alert-success|error|warning|info`.
    const base = ['alert'];

    const map: Record<string, string> = {
      neutral: '',
      info: 'alert-info',
      success: 'alert-success',
      warning: 'alert-warning',
      error: 'alert-error',
      loading: '',
    };

    return [...base, map[variant] ?? '', this.itemClassName].filter(Boolean).join(' ');
  }
}

